import { render, staticRenderFns } from "./CardBody.vue?vue&type=template&id=c93ac0ca&scoped=true&lang=pug&"
import script from "./CardBody.vue?vue&type=script&lang=js&"
export * from "./CardBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93ac0ca",
  null
  
)

export default component.exports